module.exports = __webpack_public_path__ + "static/media/stove.4304e030.svg";